import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/commonFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields, purchasedMaterialFields } from './common/productFields';
import { msg } from '@lingui/core/macro';
import { fuelKindField } from './common/fuelFields';
import {
  distanceQuantityField,
  distanceUnitField,
  isCompanyOwnedOrLeasedField,
  vehicleCategoryField,
  vehiclePowertrainTypeField,
  vehicleTypeField,
} from './common/travelFields';

export const vehiclesMetadata = {
  displayName: msg({
    message: 'Vehicle travel',
    context: 'Activity data schema name for vehicle travel',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...purchasedMaterialFields,
    distance_quantity: distanceQuantityField,
    // NOTE: quantity does not exist on the BAT but distance_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: distanceQuantityField,
    distance_unit: distanceUnitField,
    electricity_efficiency: {
      displayName: msg({
        message: 'Electricity efficiency',
        context: 'The electricity efficiency of the vehicle',
      }),
      externalDescription: msg({
        message: 'The electricity efficiency of the vehicle',
        context: 'Electricity efficiency description',
      }),
    },
    electricity_efficiency_unit: {
      displayName: msg({
        message: 'Electricity efficiency unit',
        context: 'The display name for a dimension',
      }),
    },
    fuel_efficiency: {
      displayName: msg({
        message: 'Fuel efficiency',
        context: 'The fuel efficiency of the vehicle',
      }),
      externalDescription: msg({
        message: 'The fuel efficiency of the vehicle',
        context: 'Fuel efficiency description',
      }),
    },
    fuel_efficiency_unit: {
      displayName: msg({
        message: 'Fuel efficiency unit',
        context: 'The display name for a dimension',
      }),
    },
    fuel_kind: fuelKindField,
    fuel_quantity: {
      displayName: msg({
        message: 'Fuel consumption',
        context: 'The display name for a metric',
      }),
    },
    fuel_unit: {
      displayName: msg({
        message: 'Raw fuel unit',
        context: 'The display name for a dimension',
      }),
    },
    is_company_owned_or_leased: isCompanyOwnedOrLeasedField,
    vehicle_category: vehicleCategoryField,
    vehicle_powertrain_type: vehiclePowertrainTypeField,
    vehicle_type: vehicleTypeField,
    vehicle_usage_reason: {
      displayName: msg({
        message: 'Vehicle usage reason',
        context: 'The display name for a dimension',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
